import React, { createContext } from 'react';

import type { LoadingMetricContentType } from './perf.config';
import type { MarkName } from './performanceMetricsProvider';

// oxlint-disable-next-line eslint/no-redeclare
export type PerformanceMetricsContext = {
	cancelIframeLoadMetrics: () => void;
	isInitialized: boolean;
	markIframeLoadMetrics: (markName: MarkName) => void;
	setContentType: (contentType: LoadingMetricContentType) => void;
};

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
export const PerformanceMetricsContext: React.Context<PerformanceMetricsContext> =
	createContext<PerformanceMetricsContext>({
		isInitialized: false,
		cancelIframeLoadMetrics: () => {},
		markIframeLoadMetrics: () => {},
		setContentType: () => {},
	});
